export const keynames = {
    checkUrl: "nspay-checkurl"
}